// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2r6pT","selected":"Chip_selected__390fZ"};